module.exports = __webpack_public_path__ + "img/chat.c35990d6.png";